import { render, staticRenderFns } from "./importDropdowns.vue?vue&type=template&id=82a3d6b4&scoped=true&lang=html&"
import script from "./importDropdowns.vue?vue&type=script&lang=js&"
export * from "./importDropdowns.vue?vue&type=script&lang=js&"
import style0 from "./importDropdowns.vue?vue&type=style&index=0&id=82a3d6b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a3d6b4",
  null
  
)

export default component.exports